import React from 'react';
import * as ReactDOM from "react-dom/client";
import CVMFilings from './cmv-filings';

const cvmFilingsContainer = document.getElementById('cvmFilings');
const cvmRoot = ReactDOM.createRoot(cvmFilingsContainer);

cvmRoot.render(
    <React.StrictMode>
        <CVMFilings />
    </React.StrictMode>
);